var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "old-new-section" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass: " col-md-6 d-flex align-items-lg-stretch flex-column"
            },
            [
              _c("div", { staticClass: "title__blck" }, [
                _c("div", { staticClass: "title" }, [
                  _c(
                    "p",
                    { staticClass: "p-black p-title-new relawayBold p-center" },
                    [_vm._v("Hur det brukade vara")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "desk" }, [
                  _c("p", { staticClass: "min p-dgrey  p-center" }, [
                    _vm._v(
                      "Ring runt bland Sveriges elbolag och anteckna deras priser för att hitta det avtal du tror är billigt. Kontakta sedan manuellt ditt existerande elbolag och nätbolag för att be dem att byta ditt elavtal."
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "img__blck" }, [
                _c("img", {
                  staticClass: "img-fluid first_img",
                  attrs: {
                    src: require("../../../../img/old-way-img.svg"),
                    alt: ""
                  }
                })
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                " col-md-6 d-flex align-items-lg-stretch  flex-column"
            },
            [
              _c("div", { staticClass: "title__blck" }, [
                _c("div", { staticClass: "title" }, [
                  _c(
                    "p",
                    { staticClass: "p-black p-title-new relawayBold p-center" },
                    [_vm._v("Hur det ska vara")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "desk" }, [
                  _c("p", { staticClass: "min p-dgrey  p-center" }, [
                    _vm._v(
                      "Ange ditt postnummer och årsförbrukning på TecknaEl. Vi jämför kostnadsfritt dagens priser för Sveriges elbolag och ger dig de billigaste alternativen, svart på vitt. Att byta avtal är sedan bara ett klick bort!"
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "img__blck " }, [
                _c("img", {
                  staticClass: "img-fluid",
                  attrs: {
                    src: require("../../../../img/smart-way-img.svg"),
                    alt: ""
                  }
                })
              ])
            ]
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }